import React, { useState, useEffect, useRef } from 'react';
import Card from './RoadShowCard';
import PastEventsGallery from './PastEventsGallery';

function RoadShow() {
    const missionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.3 }
        );

        if (missionRef.current) {
            observer.observe(missionRef.current);
        }
    }, [missionRef]);

    return (
        <div ref={missionRef} className='w-full bg-colourBg text-white pt-16 sm:pt-20 md:pt-24 pb-12 sm:pb-16 overflow-hidden'>
            <div className="px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24">
                <h1 className={`text-2xl sm:text-3xl lg:text-4xl font-light tracking-wider mb-6 sm:mb-8 ${isVisible ? 'animate-slideInLeft opacity-100' : 'opacity-0'}`}>
                    UPCOMING INTERNATIONAL ROADSHOWS
                </h1>
                <p className={`mb-8 sm:mb-12 max-w-2xl tracking-wide text-xs sm:text-sm md:text-base text-gray-300 leading-relaxed transition-all duration-1000 ${isVisible ? 'animate-slideInRight opacity-100' : 'opacity-0'}`}>
                    Haideries has grown into a global real estate advisory thanks to our international property events, which helps us speak to the investors and give them insights on the real estate market of Dubai. Checkout the list of our upcoming international property events, below.
                </p>
                <Card />
                <div className='border-t border-white/20 w-full my-8 md:my-16' />
                <div className='grid grid-cols-1 lg:grid-cols-8 gap-6 md:gap-8 my-4 sm:my-8'>
                    <div className={`lg:col-span-3 text-xl sm:text-2xl lg:text-3xl font-light tracking-wider ${isVisible ? 'animate-slideInTop2 opacity-100' : 'opacity-0'}`}>
                        WHY ATTEND ROADSHOWS?
                    </div>
                    <div className={`lg:col-span-5 text-xs sm:text-sm md:text-base leading-relaxed text-gray-300 ${isVisible ? 'animate-slideInRight opacity-100' : 'opacity-0'}`}>
                        Embark on an enlightening journey with Haideries Real Estate, having conducted over 200 international roadshows since 2021. Our endeavors have not only showcased the vibrant allure of Dubai but also emphasized the inviting atmosphere it extends to global investors. Discover comprehensive insights into the Dubai real estate market, property prices, mortgages, and exclusive offers directly from developers. Join us in unraveling the limitless possibilities that Dubai holds for you.
                    </div>
                </div>

                <div className='border-t border-white/20 w-full my-8 md:my-16' />
                <PastEventsGallery />
            </div>
        </div>
    );
}

export default RoadShow;
